/**
 * Serves as finish point for me permissions in MeStateModel.permissions.project
 * @updated 04/11/2024
 * @public
 * @param ctx StateContext<MeStateModel>
 * @see libs/app/client/shared/states/src/lib/me/states/me.state.ts
 */ export class SetPermissionsSuccess {
  public static readonly type = '[Me] SetMePermissionsSuccess';
}
